<template>
  <div class="first-app">
    <div class="login_box" v-show="!dialogVisible">
      <!-- 头像区域 -->
      <div class="avatar_box">登录</div>

      <!-- 登录表单区 -->
      <el-form
        ref="loginFormref"
        :model="loginForm"
        class="login_form"
        :rules="loginformrules"
      >
        <!-- 用户名 -->
        <el-form-item prop="loginName">
          <el-input
            prefix-icon="el-icon-user"
            v-model="loginForm.loginName"
          ></el-input>
        </el-form-item>

        <!-- 密码 -->
        <el-form-item prop="password">
          <el-input
            prefix-icon="el-icon-lock"
            v-model="loginForm.password"
            type="password"
            show-password
          ></el-input>
        </el-form-item>

        <!-- 按钮区域 -->
        <el-form-item class="btns">
          <el-button type="primary" @click="login">登录</el-button>
          <el-button @click="dialogVisible = true">注册</el-button>
        </el-form-item>
      </el-form>
    </div>
    {{ msg }}
  </div>
</template>

<script>
import qs from 'qs'

export default {
  name: 'TheFirst',
  data () {
    return {
      msg: 'welcome materials-lab.',
      // 这是登录表单的数据绑定对象
      loginForm: {
        loginName: '',
        password: ''
      },
      // 这是表单的验证对象
      loginformrules: {
        // 验证用户名是否合法
        loginName: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          {
            min: 3,
            max: 10,
            message: '长度在 3 到 10 个字符',
            trigger: 'blur'
          }
        ],
        // 验证密码是否合法
        password: [
          { required: true, message: '请输入登录密码', trigger: 'blur' },
          {
            min: 6,
            max: 16,
            message: '长度在 6 到 16 个字符',
            trigger: 'blur'
          }
        ],
        repassword: [
          { required: true, message: '确认密码', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value === '') {
                callback(new Error('请再次输入密码'))
              } else if (value !== this.registerForm.password) {
                callback(new Error('两次输入密码不一致'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ]
      },
      // 注册对话框显示
      dialogVisible: false,
      // 注册的用户数据
      registerForm: {
        loginName: '',
        password: ''
      }
    }
  },
  mounted () {},
  created () {
    // 回车登录
    var t = this
    document.onkeydown = function (e) {
      var key
      if (window.event === undefined) {
        key = e.keyCode
      } else {
        key = window.event.keyCode
      }
      // enter的ASCII码是13
      if (key === 13) {
        // t.登录方法
        t.login()
      }
    }
  },
  methods: {
    // 登录实现
    login () {
      this.$refs.loginFormref.validate(async (valid) => {
        if (!valid) return
        const { data: res } = await this.$http.post(
          '/manage/login',
          this.loginForm
        )
        // const { data: res } = await this.$http.post('login', this.loginForm);
        console.log(res)
        if (res.code !== 1) {
          return this.$message.error('账号或密码错误，登录失败！')
          // this.$message.success('登录成功！')
        }
        if (res.body.type === '0') {
          // token是登录的凭证，保存在sssionStorage中
          window.sessionStorage.setItem('token', res.body.token)
          // 通过编程式导航跳转到后台页面 路由地址是/home
          this.$router.push({ name: 'home', params: { showadmin: true } })
          console.log(res.body.type)
        } else {
          window.sessionStorage.setItem('token', res.body.token)
          // 通过编程式导航跳转到后台页面 路由地址是/home
          this.$router.push({ name: 'home', params: { showadmin: false } })
          console.log(res.body.type)
        }
      })
    },

    // 重置表单内容
    reset () {
      this.$refs.registerFormref.resetFields()
    },

    // 注册用户
    register () {
      this.$refs.registerFormref.validate(async (valid) => {
        // 预校验通过可以发起注册的网络请求
        if (!valid) return
        const { data: res } = await this.$http.post(
          'api/reguser',
          qs.stringify({
            loginName: this.registerForm.loginName,
            password: this.registerForm.password,
            power: '普通用户'
          })
        )
        if (res.status !== 200) {
          return this.$message.error('注册用户失败！')
        }
        this.$message.success('注册成功！')
        this.dialogVisible = false
      })
    }
  }
}
</script>

<style lang='less' scoped>
.login_container {
  background: require('../../assets/1.jpg');
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  min-width: 1000px;
  zoom: 1;
  background-color: #fff;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center 0
}

.login_box {
  width: 350px;
  height: 250px;
  position: absolute;
  left: 75%;
  top: 9%;
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.2)
}

.login_box .avatar_box {
  margin: 15px auto 0 auto;
  font-size: 25px;
  font-weight: 500;
  letter-spacing: 8px;
  text-align: center;
  color: rgb(255, 255, 255)
}

.btns {
  display: flex;
  justify-content: left
}

.btns .el-button {
    width: 150px;
    letter-spacing: 8px
}

.login_form {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box
}
</style>



// WEBPACK FOOTER //
// src/components/views/First.vue